let makeObject = {
    "Audi": {
        "A1": {
            "S-Line 8X": [
                "2014-2018"
            ],
            "S-Line 8Y": [
                "2018-2025"
            ]
        },
        "S1": {
            "8X": [
                "2014-2018"
            ]
        },
        "A3": {
            "S-Line 8P Pre-Facelift": [
                "2004-2008"
            ],
            "S-Line 8P Facelift": [
                "2008-2013"
            ],
            "S-Line 8V Pre-Facelift Hatchback": [
                "2013-2016"
            ],
            "S-Line 8V Pre-Facelift Saloon": [
                "2013-2016"
            ],
            "S-Line 8V Pre-Facelift Sportback": [
                "2013-2016"
            ],
            "S-Line 8V Facelift Hatchback": [
                "2016-2020"
            ],
            "S-Line 8V Facelift Saloon": [
                "2016-2020"
            ],
            "S-Line 8V Facelift Sportback": [
                "2016-2020"
            ]
        },
        "S3": {
            "8P Hatchback": [
                "2006-2013"
            ],
            "8V Pre-Facelift Hatchback": [
                "2013-2016"
            ],
            "8V Pre-Facelift Saloon": [
                "2013-2016"
            ],
            "8V Pre-Facelift Sportback": [
                "2013-2016"
            ],
            "8V Facelift Hatchback": [
                "2016-2020"
            ],
            "8V Facelift Saloon": [
                "2016-2020"
            ],
            "8V Facelift Sportback": [
                "2016-2020"
            ]
        },
        "RS3": {
            "8V Pre-Facelift Sportback": [
                "2015-2016"
            ],
            "8V Facelift Saloon": [
                "2016-2020"
            ],
            "8Y Pre-Facelift Saloon": [
                "2020-2024"
            ],
            "8Y Pre-Facelift Sportback": [
                "2020-2024"
            ]
        }, 
        "RSQ3": {
            "8U Pre-Facelift": [
                "2013-2016"
            ],
            "8U Facelift": [
                "2016-2018"
            ]               
        },
        "TT": {
            "MK2 S-Line Pre-Facelift": [
                "2006-2010"
            ],
            "MK2 S-Line Facelift": [
                "2011-2013"
            ],
            "MK3 TFSI Pre-Facelift": [
                "2014-2018"
            ],
            "MK3 S-Line Pre-Facelift": [
                "2014-2018"
            ],
            "MK3 S-Line Facelift": [
                "2018-2023"
            ]
        },
        "TTS": {
            "MK2 Pre-Facelift": [
                "2006-2010"
            ],
            "MK2 Facelift": [
                "2011-2013"
            ],
            "MK3 Pre-Facelift": [
                "2014-2018"
            ],
            "MK3 Facelift": [
                "2018-2023"
            ]
        },
        "TTRS": {
            "MK3 Pre-Facelift": [
                "2014-2018"
            ],
            "MK3 Facelift": [
                "2018-2023"
            ]
        },
        "A4": {
            "S-Line B9 Avant": [
                "2015-2019"
            ],
            "S-Line B9 Saloon": [
                "2015-2019"
            ],
            "S-Line B9-5 Saloon": [
                "2019-2024"
            ]    
        },
        "S4": {
            "B9 Avant": [
                "2015-2019"
            ],
            "B9 Saloon": [
                "2015-2019"
            ]
        },
        "RS4": {
            "B7 Avant": [
                "2006-2008"
            ],
            "B7 Cabriolet": [
                "2006-2008"
            ],
            "B7 Saloon": [
                "2006-2008"
            ],
            "B9 Avant": [
                "2017-2019"
            ],
            "B9-5 Avant": [
                "2019-2025"
            ]
        },
        "A5": {
            "S-Line B9 Coupe": [
                "2016-2019"
            ],
            "S-Line B9 Sportback": [
                "2016-2019"
            ],
            "S-Line B9-5 Coupe": [
                "2019-2025"
            ]
        },
        "S5": {
            "B9 Coupe": [
                "2016-2019"
            ],
            "B9 Sportback": [
                "2016-2019"
            ],
            "B9-5 Coupe": [
                "2019-2025"
            ]
        },
        "RS5": {
            "B9 Coupe": [
                "2017-2019"
            ],
            "B9 Sportback": [
                "2017-2019"
            ],
            "B9-5 Coupe": [
                "2019-2025"
            ],
            "B9-5 Sportback": [
                "2019-2025"
            ]
        },
        "S6": {
            "C7-5 Avant": [
                "2016-2018"
            ],
            "C7-5 Saloon": [
                "2016-2018"
            ]
        },
        "RS6": {
            "C7 Avant": [
                "2013-2014"
            ],
            "C7 Saloon": [
                "2013-2014"
            ],
            "C7-5 Avant": [
                "2015-2018"
            ],
            "C7-5 Saloon": [
                "2015-2018"
            ]
        },
        "R8": {
            "Gen 1 Pre-Facelift": [
                "2006-2012"
            ],
            "Gen 1 Facelift": [
                "2013-2015"
            ],
            "Gen 2": [
                "2015-2018"
            ]
        }
    },
    "BMW": {
        "1 Series": {
            "135i F20": [
                "2011-2015"
            ],
            "135i F21": [
                "2011-2015"
            ],
            "140i F20": [
                "2015-2019"
            ],
            "140i F21": [
                "2015-2019"
            ]
        },
        "2 Series": {
            "M2 F87 Competition": [
                "2016-2020"
            ]
        },
        "4 Series": {
            "M4 F82": [
                "2014-2020"
            ]
        },    
        "5 Series": {
            "M5 F10": [
                "2011-2016"
            ]
        }
    },
    "Citroen": {
        "DS3": {
            "DS3": [
                "2009-2015"
            ]
        }
    },
    "Cupra": {
        "Leon": {
            "MK4": [
                "2020-2025"
            ]
        }
    },
    "Fiat Abarth": {
        "500": {
            "Series-3": [
                "2008-2015"
            ]
        },
        "595": {
            "Series-3": [
                "2008-2015"
            ],
            "Series-4": [
                "2016-2025"
            ]
        },
        "695": {
            "Series-3": [
                "2008-2015"
            ],
            "Series-4": [
                "2016-2025"
            ]
        }
    },
    "Ford": {
        "Escort": {
            "Series 1 RS Turbo": [
                "1984-1986"
            ]
        },      
        "Fiesta": {
            "MK5 Zetec-S": [
                "1999-2004"
            ],
            "MK6 Zetec-S": [
                "2004-2007"
            ],
            "MK6 ST150": [
                "2004-2007"
            ],
            "MK7 Zetec-S": [
                "2008-2013"
            ],
            "MK7-5 ST-Line": [
                "2013-2017"
            ],
            "MK7-5 ST180": [
                "2013-2017"
            ],
            "MK8 ST-Line": [
                "2017-2021"
            ],
            "MK8 ST": [
                "2018-2021"
            ],
            "MK8-5 ST-Line": [
                "2021-2024"
            ],
            "MK8-5 ST": [
                "2021-2024"
            ]
        },
        "Focus": {
            "MK2 ST225": [
                "2004-2007"
            ],
            "MK2 RS": [
                "2008-2011"
            ],
            "MK2-5 Zetec S": [
                "2009-2011"
            ],
            "MK2-5 ST225": [
                "2008-2011"
            ],
            "MK3 Zetec S": [
                "2011-2014"
            ],
            "MK3 ST250": [
                "2012-2014"
            ],
            "MK3 ST250 Estate": [
                "2012-2014"
            ],
            "MK3 RS": [
                "2016-2018"
            ],
            "MK3-5 ST-Line": [
                "2014-2018"
            ],
            "MK3-5 ST250": [
                "2015-2018"
            ],
            "MK3-5 ST250 Estate": [
                "2015-2018"
            ],
            "MK4 ST-Line": [
                "2018-2021"
            ],
            "MK4 ST": [
                "2019-2021"
            ],
            "MK4-5 ST-Line": [
                "2021-2025"
            ],
            "MK4-5 ST": [
                "2021-2025"
            ]
        },
        "Mondeo": {
            "MK3 ST220": [
                "2002-2007"
            ],
            "MK5 ST-Line": [
                "2014-2018"
            ]
        },
        "Mustang": {
            "2-3L EcoBoost": [
                "2014-2017"
            ],
            "S550 5-0L GT Pre-Facelift": [
                "2014-2017"
            ],
            "5-0L GT Facelift": [
                "2017-2023"
            ]
        },        
        "Puma": {
            "ST-Line": [
                "2019-2024"
            ],
            "ST": [
                "2020-2024"
            ]
        },
        "Transit Connect": {
            "MK2 Pre-Facelift Short-Wheelbase": [
                "2012-2017"
            ],
            "MK2 Pre-Facelift Long-Wheelbase": [
                "2012-2017"
            ],
            "MK2 Facelift Short-Wheelbase": [
                "2017-2023"
            ],
            "MK2 Facelift Long-Wheelbase": [
                "2017-2023"
            ]
        },
        "Transit Courier": {
            "MK1": [
                "2014-2017"
            ]    
        }
    },
    "Honda": {
        "Civic": {
            "Type-R FK2": [
                "2015-2017"
            ]
        }
    },
    "Hyundai": {
        "I30N": {
            "Hatchback Pre-Facelift": [
                "2017-2020"
            ],
            "Fastback Pre-Facelift": [
                "2017-2020"
            ],
            "Hatchback Facelift": [
                "2021-2024"
            ],
            "Fastback Facelift": [
                "2021-2024"  
            ]    
        }
    },
    "Lotus": {
        "Emira": {
            "Emira": [
                "2022-2025"
            ]  
        }
    },    
    "Mazda": {
        "3": {
            "MK1 MPS": [
                "2007-2009"
            ]
        },
        "RX7": {
            "FD3S": [
                "1992-2003"
            ]
        }
    },
    "Mercedes": {
        "A Class": {
            "A35 AMG W177": [
                "2018-2023"
            ],
            "A45 AMG Pre-Facelift Non-Aero W176": [
                "2013-2015"
            ],
            "A45 AMG Facelift Aero W176": [
                "2015-2018"
            ]
        }
    },
    "Mini": {
        "Cooper S": {
            "R53": [
                "2001-2006"
            ],
            "R56 JCW": [
                "2006-2010"
            ],
            "R58 JCW": [
                "2006-2010"
            ],
            "F56 JCW": [
                "2017-2020"
            ]
        }
    },
    "Nissan": {
        "R35": {
            "GTR": [
                "2007-2022"
            ]
        }
    },
    "Peugeot": {
        "208": {
            "GTI": [
                "2013-2019"
            ]
        },
        "308": {
            "GTI": [
                "2017-2021"
            ]
        }
    },
    "Porsche": {
        "Taycan": {
            "Pre-Facelift": [
                "2019-2024"
            ]
        }
    },
    "Renault": {
        "Clio": {
            "MK3 RS200": [
                "2009-2012"
            ]
        }
    },
    "Seat": {
        "Ibiza": {
            "MK4 Cupra 6L": [
                "2004-2008"
            ],
            "MK5 Cupra Pre-Facelift 6J": [
                "2008-2012"
            ],
            "MK5 FR Facelift 6J": [
                "2012-2017"
            ],
            "MK5 Cupra Facelift 6J": [
                "2012-2017"
            ],
            "MK6 FR 6F": [
                "2017-2021"
            ]
        },
        "Leon": {
            "MK1 Cupra R": [
                "2002-2006"
            ],
            "MK2 FR Pre-Facelift": [
                "2005-2009"
            ],
            "MK2 Cupra Pre-Facelift": [
                "2005-2009"
            ],
            "MK2 FR Facelift": [
                "2009-2012"
            ],
            "MK2 Cupra Facelift": [
                "2009-2012"
            ],
            "MK2 BTCC": [
                "2005-2009"
            ],
            "MK2 K1": [
                "2005-2009"
            ],
            "MK3 FR": [
                "2012-2016"
            ],
            "MK3 Cupra": [
                "2012-2016"
            ],
            "MK3-5 FR": [
                "2017-2020"
            ],
            "MK3-5 Cupra": [
                "2017-2020"
            ]
        }
    },
    "Skoda": {
        "Fabia": {
            "MK2 VRS": [
                "2010-2014"
            ]
        },    
        "Octavia": {
            "MK2 VRS": [
                "2008-2013"
            ]
        }  
    },          
    "Tesla": {
        "Model-3": {
            "Model-3": [
                "2017-2023"
            ]
        }
    },
    "Toyota": {
        "GR Yaris": {
            "GR Yaris": [
                "2020-2025"
            ]
        }
    },
    "Vauxhall": {
        "Adam": {
            "S": [
                "2013-2019"
            ]
        },   
        "Astra": {
            "H VXR": [
                "2005-2010"
            ],
            "J VXR": [
                "2009-2012"
            ]
        },      
        "Corsa": {
            "D LE": [
                "2011-2014"
            ],
            "D VXR": [
                "2004-2014"
            ],
            "E LE": [
                "2015-2019"
            ],
            "E VXR": [
                "2015-2019"
            ]
        },      
        "Insignia": {
            "VXR": [
                "2009-2017"
            ]
        }
    },
    "Volkswagen": {
        "Caddy": {
            "MK3-2K": [
                "2010-2015"
            ],
            "MK3-2K-Maxi": [
                "2010-2015"
            ],
            "MK4-2KN": [
                "2015-2020"
            ],
            "MK4-2KN-Maxi": [
                "2015-2020"
            ],
            "MK5": [
                "2020-2025"
            ],
            "MK5-Maxi": [
                "2020-2025"
            ]
        },      
        "Golf": {
            "MK4 R32": [
                "2002-2004"
            ],
            "MK5 GTI": [
                "2003-2008"
            ],
            "MK5 R32": [
                "2003-2008"
            ],
            "MK6 GTD": [
                "2008-2012"
            ],
            "MK6 GTI": [
                "2008-2012"
            ],
            "MK6 R": [
                "2008-2012"
            ],
            "MK7 GTD": [
                "2013-2016"
            ],
            "MK7 GTI": [
                "2013-2016"
            ],
            "MK7 R": [
                "2013-2016"
            ],
            "MK7-5 GTD": [
                "2017-2019"
            ],
            "MK7-5 GTI": [
                "2017-2019"
            ],
            "MK7-5 R": [
                "2017-2020"
            ],
            "MK8 GTD": [
                "2020-2024"
            ],
            "MK8 GTI": [
                "2020-2024"
            ],
            "MK8 R": [
                "2020-2025"
            ]
        },
        "ID3": {
            "ID3 Pre-Facelift": [
                "2019-2023"
            ],
            "ID3 Facelift": [
                "2024-2026"
            ]  
        },     
        "Polo": {
            "MK5 R-Line": [
                "2013-2017"
            ],
            "MK5 GT": [
                "2009-2017"
            ], 
            "MK5 GTI 6R": [
                "2009-2014"
            ],    
            "MK6 GTI": [
                "2017-2021"
            ]
        },
        "Scirocco": {
            "MK3 Pre-Facelift": [
                "2008-2014"
            ],
            "MK3 GTS Facelift": [
                "2014-2017"
            ],
            "MK3 R-Line Facelift": [
                "2014-2017"
            ],
            "MK3 R Facelift": [
                "2014-2017"
            ]
        },
        "Transporter": {
            "T5 ABT Short-Wheelbase": [
                "2003-2015"
            ],
            "T5 ABT Long-Wheelbase": [
                "2003-2015"
            ],
            "T5 Sportline Short-Wheelbase": [
                "2003-2015"
            ],
            "T5 Sportline Long-Wheelbase": [
                "2003-2015"
            ],
            "T6 Non-Sportline Short-Wheelbase": [
                "2015-2019"
            ],
            "T6 Non-Sportline Long-Wheelbase": [
                "2015-2019"
            ],
            "T6 Sportline Short-Wheelbase": [
                "2015-2019"
            ],
            "T6 Sportline Long-Wheelbase": [
                "2015-2019"
            ],
            "T6-1 Sportline Short-Wheelbase": [
                "2019-2024"
            ],
            "T6-1 Sportline Long-Wheelbase": [
                "2019-2024"                                
            ]
        }
    }
}